<template>
    <span :class="`zt-icon zt-icon-${type} ${className}`" :style="domStyle" v-html="svgHtml"></span>
</template>


<script>
import {Prop, Vue} from 'vue-property-decorator';
import icons from './icons';
import './index.scss';

export default class ZTIcon extends Vue {

    @Prop({type: String, default: ''}) type;
    @Prop({type: Object, default: function(){return {}}}) domStyle;
    @Prop({type: String, default: ''}) className;

    get svgHtml() {
        return icons[this.type];
    }
}
</script>
